import React from "react";
import {
  ContainerReports,
  ContainerIframe,
} from "./ReportsEngagementContainer.styled";

const ReportsEngagementContainer = () => {
  const iframe =
    '<iframe title="Engagement" src="https://app.powerbi.com/reportEmbed?reportId=c8744d80-11a3-41cf-ad48-2c47fbbd920d&autoAuth=true&ctid=638fcbaf-ba4c-43e1-adae-5475c970fe10" style="border: 0px; overflow: hidden; width: 100%; height: 100%; min-height: 610px;"></iframe>';

  return (
    <ContainerReports>
      <ContainerIframe
        contentEditable="true"
        dangerouslySetInnerHTML={{ __html: iframe }}
      ></ContainerIframe>
    </ContainerReports>
  );
};

export default ReportsEngagementContainer;
